"use client";

import React, { useState } from "react";
import type { ContentBlock } from "@/types";

interface Props {
  title: string;
  contentBlocks?: ContentBlock[];
}

// SEO content-accordion ("MEER INFORMATIE OVER ...") — gedeeld tussen categorie-,
// merk- en salepagina's zodat de in de admin ingevulde blokken overal hetzelfde
// renderen i.p.v. per pagina apart gebouwd te worden.
export default function CategoryContentAccordion({ title, contentBlocks }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  if (!contentBlocks || contentBlocks.length === 0) return null;

  return (
    <div style={{
      margin: "48px 0 24px 0",
      border: "1px solid #e5e5e5",
      borderRadius: "6px",
      overflow: "hidden",
      background: "#fafafa"
    }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: "100%",
          textAlign: "left",
          padding: "18px 24px",
          background: "#fff",
          border: "none",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 700,
          fontSize: "0.95rem",
          color: "var(--color-primary)",
          letterSpacing: "0.05em"
        }}
      >
        MEER INFORMATIE OVER {title.toUpperCase()}
        <span style={{ fontSize: "0.85rem", color: "var(--color-primary)", marginLeft: "12px", transition: "transform 0.2s" }}>
          {isOpen ? "▲ LEES MINDER" : "▼ LEES MEER"}
        </span>
      </button>
      {isOpen && (
        <div style={{
          padding: "24px",
          borderTop: "1px solid #e5e5e5",
          background: "#fff",
          lineHeight: 1.75
        }}>
          {contentBlocks.map((block, i) => (
            <div key={i} style={{ marginBottom: i < contentBlocks.length - 1 ? "24px" : 0 }}>
              {block.heading && (
                <h3 style={{
                  fontSize: "1.1rem",
                  fontWeight: 700,
                  color: "#1a1a1a",
                  marginBottom: "12px",
                  textTransform: "uppercase"
                }}>
                  {block.heading}
                </h3>
              )}
              {block.paragraphs.map((p, pi) => p && (
                <p key={pi} style={{ color: "#444", fontSize: "0.9rem", marginBottom: "12px", textAlign: "justify" }}>
                  {p}
                </p>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
